import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TrashIcon } from "../../../assets/icons";
import { APP_URLS } from '../../../app/config';

function ComplainAttachments({ id, attachments, onUpdate, onPhotoRemove }) {
    const { t } = useTranslation('ComplainDetailsScreen', { keyPrefix: 'Attachments' });

    const handleRemoveFile = async (file) => {
        if (onPhotoRemove) {
            await onPhotoRemove(file);
        }
        if (onUpdate) {
            await onUpdate();
        }
    }

    if (!attachments?.length)
        return null;

    return (
        <div className="fk-form-section">
            <h3 className="title">
                {t('formTitle')}
            </h3>
            <Grid container spacing={2}>
                <Grid item md={2} />
                <Grid item md={8}>
                    <ul className="fk-files-list">
                        <li>
                            {t('attachments')}
                            <a href={`${APP_URLS.BASE}/api/Report/${id}/downloadAllAttachments`} target="_blank" rel="noreferrer">[{t('downloadAll')}]</a>
                        </li>
                        {attachments.map((file) => (
                            <li key={file.fileName}>
                                <div className="file-name-container">
                                    {file.fileName}
                                </div>
                                <div className="file-icons-container">
                                    <a href={`${APP_URLS.BASE}${file.path}`} target="_blank" rel="noreferrer">[{t('download')}]</a>
                                    <button onClick={() => handleRemoveFile(file.path)}>
                                        <img src={TrashIcon} alt="" />
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>
                </Grid>
                <Grid item md={2} />
            </Grid>
        </div>
    );
}

export default ComplainAttachments;
